import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Datepicker from 'react-datepicker'
import moment from 'moment'

import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import styles from 'components/Input/styles.css'
import './styles.css'

moment.locale('sv')

/**
 * For all available options see plugin documentation
 * @link https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md
 */

class DatePicker extends Component {
  static propTypes = {
    className: PropTypes.string,
    dateFormat: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.node,
    value: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    dateFormat: 'YYYY-MM-DD',
    label: '',
    description: null,
    value: '',
    error: '',
    onChange: date => console.log('onChange', date),
  }

  onChange = date => {
    this.props.onChange(date.format(this.props.dateFormat))
  }

  getClassName() {
    return classnames(
      styles.root,
      {
        [styles.required]: this.props.required, // eslint-disable-line react/prop-types
        [styles.disabled]: this.props.disabled, // eslint-disable-line react/prop-types
      },
      this.props.className,
    )
  }

  render() {
    const {
      className,
      label,
      description,
      value,
      error,

      ...restProps
    } = this.props

    const datePickerProps = {
      ...restProps,
      onChange: this.onChange,
    }

    if (value) {
      datePickerProps.selected = moment(value)
    }

    return (
      <div className={this.getClassName()}>
        {label && <div className={styles.label}>{label}</div>}

        <Datepicker {...datePickerProps} />

        {description && <div className={styles.description}>{description}</div>}

        {error && <div className={styles.error}>{error}</div>}
      </div>
    )
  }
}

export default DatePicker



// WEBPACK FOOTER //
// ../source/components/DatePicker/index.js